import * as React from "react";

import { PostFeedItem } from "../../../../../models";
import Tile from "./Tile";

import "../../../styles/List.sass";

const List: React.FunctionComponent<ComponentProps> = props => {
  return (
    <div className="list">
      {props.postsFeed.map(post => <Tile key={post.id} {...props} post={post} />)}
    </div>
  );
}

interface ComponentProps {
  cardCount: number;
  hidePublishTime?: boolean;
  hideReadDate?: boolean;
  hideStats?: boolean;
  hideSummary?: boolean;
  hideTopics?: boolean;
  postsFeed: PostFeedItem[];
  preferredLCID: string;
  onPostSelected: (post: PostFeedItem) => void;
}

export default List;